module.exports = __webpack_public_path__ + "static/media/outline-sm-white2.f725af2e.png";